module.exports = __webpack_public_path__ + "img/tree-1.5e394ff9.png";